/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Reality_CechyInputs */

const cs_enum_reality_cechy = /** @type {(inputs: Enum_Reality_CechyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reality Čechy`)
};

const en_enum_reality_cechy = /** @type {(inputs: Enum_Reality_CechyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reality Čechy`)
};

/**
* | output |
* | --- |
* | "Reality Čechy" |
*
* @param {Enum_Reality_CechyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_reality_cechy = /** @type {((inputs?: Enum_Reality_CechyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Reality_CechyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_reality_cechy(inputs)
	return cs_enum_reality_cechy(inputs)
});